/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Modifiedby1Inputs */

const en_entity_modifiedby1 = /** @type {(inputs: Entity_Modifiedby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modified By`)
};

const de_entity_modifiedby1 = /** @type {(inputs: Entity_Modifiedby1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geändert von`)
};

/**
* | output |
* | --- |
* | "Modified By" |
*
* @param {Entity_Modifiedby1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_modifiedby1 = /** @type {((inputs?: Entity_Modifiedby1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Modifiedby1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_modifiedby1(inputs)
	return de_entity_modifiedby1(inputs)
});
export { entity_modifiedby1 as "entity_modifiedBy" }